<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .countryname_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  .sub_table1{width: 400px;text-align:center;
  .canshuname{width: 100px !important;}
  .canshuvalue{width: 200px !important;}}
  .sub_table2{width: 400px;
  .first{width: 126px;}
  .el-input{width: 100px;margin: 0px 5px;}}
  .radio{font-size: 16px;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
  /deep/.hide .el-upload--picture-card {display: none;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" :rules="rules" class="formBox">
      <table>
       <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('catid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>所属分类
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.catid" placeholder="请选择分类" class="select classification">
                <el-option v-for="item in classifydata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked_External_links">外部链接</el-checkbox>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('title')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享标题
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.title" class="input title" @blur="detection(11, 18, form.title)"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="form.level" placeholder="请选择级别" class="select level">
                <el-option v-for="item in level_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="td_left">
            <span v-if="isMandatory('thumb')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>标题图片
          </td>
          <td class="after">
            <el-upload
              v-if="this.$route.path === '/Sjgxgl'"
              :action="url"
              :limit="1"
              list-type="picture-card"
              ref="uploadPic"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-upload
              v-else
              :action="url"
              :limit="1"
              list-type="picture-card"
              :file-list="fileList1"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width=100% />
            </el-dialog>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('endataname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据名称（英文）
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.endataname" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('zhdataname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据名称（中文）
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.zhdataname" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('dataserialnu')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>资料档号
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.dataserialnu" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('contenttype')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文件标识
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.contenttype" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('filetype')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文件类型
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.filetype" placeholder="请选择类型" class="select classification">
                <el-option v-for="item in filetypedata" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('centergeocoordinates')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>中心地理坐标
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.centergeocoordinates" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('easternlongitude')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>东边经度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.easternlongitude" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('westlongitude')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>西边经度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.westlongitude" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('southernlatitude')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>南边纬度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.southernlatitude" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('northlatitude')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>北边纬度
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.northlatitude" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="catid_tr">
          <td class="td_left">
            <span v-if="isMandatory('datashowmethodname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据表示方法
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.datashowmethodname" placeholder="请选择方法" class="select classification">
                <el-option v-for="item in datashowmethod" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('scale')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>比例尺
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.scale" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('language')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>语言
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.language" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('dataowner')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据所属方
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.dataowner" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('datastorage')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据存储方
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.datastorage" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('datasubmit')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据提交方
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.datasubmit" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('linkman')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系人
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.linkman" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('linkmethod')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>联系方式
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.linkmethod" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('menu')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>目录
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.menu" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="countryname_tr">
          <td class="td_left">
            <span v-if="isMandatory('countryname')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>国家
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.countryname" placeholder="请选择国家" class="select level">
                <el-option v-for="item in ssgj_data" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('datapublishtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据发布时间
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.datapublishtime" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('uid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>用户ID
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.uid" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('weight')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>weight
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.weight" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('filesign')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>文件识别号
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.filesign" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('uuid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>唯一ID
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.uuid" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr2">
          <td class="td_left">
            <span v-if="isMandatory('dataid')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据ID
          </td>
          <td class="after title_right">
            <el-form-item>
              <el-input v-model="form.dataid" class="input title"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="checked_External_links">
          <td class="td_left"><span v-if="isMandatory('http')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>链接地址
          </td>
          <td class="after">
            <el-form-item>
              <el-input placeholder="请输入内容" v-model="form.http">
                <template slot="prepend">http://www.</template>
              </el-input>
            </el-form-item>
          </td>
        </tr>
        <tr v-if="!checked_External_links" >
          <td class="td_left">
            <span v-if="isContentMandatory('content')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享内容
          </td>
          <td class="after">
            <div id="editor" style="position:relative;z-index: 1;"></div>
          </td>
        </tr>
        <tr class="jianjie_tr">
          <td class="td_left">
            <span v-if="isMandatory('introduce')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享简介
          </td>
          <td class="after">
            <el-form-item>
              <el-input type="textarea" v-model="form.introduce" :rows="2" class="introduce" style="font-size: 15px;"></el-input>
            </el-form-item>
          </td>
        </tr>
       <tr class="author_tr">
          <td class="td_left">
            <span v-if="isMandatory('author')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享作者
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.author"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="copyfrom_tr">
          <td class="td_left">
            <span v-if="isMandatory('copyfrom')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>数据共享来源
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.copyfrom" placeholder="例如：新华社" class="copyfrom"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="link_tr">
          <td class="td_left">
            <span v-if="isMandatory('fromurl')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>来源链接
          </td>
          <td class="after">
            <el-form-item prop="fromurl">
              <el-input v-model="form.fromurl" placeholder="http://www." class="copyfrom"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tag_tr">
          <td class="td_left">
            <span v-if="isMandatory('tag')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>关键词(Tag)
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.tag" placeholder="多个关键词请用空格隔开"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="addtime_tr" v-if="this.$route.path === '/Sjgxgl'">
          <td class="td_left">
            <span v-if="isMandatory('addtime')" class="f_red">*</span>
            <span v-else class="f_hid">*</span>发布时间
          </td>
          <td class="after">
            <el-form-item>
              <div class="block">
                <el-date-picker v-model="form.addtime" value-format="timestamp" type="datetime" placeholder="请选择添加时间，不选则默认当前时间"></el-date-picker>
              </div>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Sjgxgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/SjgxUpdate'">确定</el-button>
      <el-button type="success" @click="isPass()" v-if="this.$route.path === '/SjgxLook'">通过</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Sjgxgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/SjgxUpdate'">返回</el-button>
      <el-button type="danger" @click="notPass()" v-if="this.$route.path === '/SjgxLook'">不通过</el-button>
      <el-button  @click="backtrackLook()" v-if="this.$route.path === '/SjgxLook'">返回</el-button>
    </div>
  </div>
</template>
<script>
/**
 * 何宽
 * 数据共享后台添加页
 */
import {mapState} from 'vuex'
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      url: '',
      checked_External_links: false,
      form: {
        catid: null,
        title: '',
        level: '',
        thumb: '',
        endataname: '',
        zhdataname: '',
        dataserialnu: '',
        contenttype: '',
        filetype: '',
        centergeocoordinates: '',
        easternlongitude: '',
        westlongitude: '',
        southernlatitude: '',
        northlatitude: '',
        datashowmethodname: '',
        scale: '',
        language: '',
        dataowner: '',
        datastorage: '',
        datasubmit: '',
        linkman: '',
        linkmethod: '',
        menu: '',
        countryname: '',
        datapublishtime: null,
        uid: null,
        weight: null,
        filesign: '',
        uuid: '',
        dataid: null,
        content: '',
        introduce: '',
        author: '',
        copyfrom: '',
        fromurl: '',
        tag: '',
        addtime: null,
        edittime: null
      },
      // 富文本对象
      editor: null,
      //所属分类数据
      classifydata: [],
      //文件类型
      filetypedata: [
        { value: '图件', label: '图件' },
        { value: '图表', label: '图表' },
        { value: '文献', label: '文献' },
        { value: '报告', label: '报告' }
      ],
      // 数据表示方法
      datashowmethod: [
        { value: '栅格', label: '栅格' },
        { value: '矢量', label: '矢量' },
        { value: '数字文档', label: '数字文档' },
        { value: '文本', label: '文本' },
        { value: '未知', label: '未知' }
      ],
      level_data: [
        { value: '1', label: '1 级 网站首页推荐' },
        { value: '2', label: '2 级' },
        { value: '3', label: '3 级' },
        { value: '4', label: '4 级' },
        { value: '5', label: '5 级' },
        { value: '6', label: '6 级' },
        { value: '7', label: '7 级' },
        { value: '8', label: '8 级' },
        { value: '9', label: '9 级' }
      ],
      ssgj_data: [
        { value: 0, label: '不限地区' },
        { value: 2, label: '中国' },
        { value: 3, label: '印度尼西亚' },
        { value: 4, label: '马来西亚' },
        { value: 5, label: '菲律宾' },
        { value: 6, label: '新加坡' },
        { value: 7, label: '泰国' },
        { value: 8, label: '文莱' },
        { value: 9, label: '越南' },
        { value: 10, label: '老挝' },
        { value: 11, label: '缅甸' },
        { value: 12, label: '柬埔寨' },
        { value: 13, label: '其它' },
        { value: 14, label: '东帝汶' }
      ],
      //预览弹框
      dialogVisible: false,
      //预览路径
      dialogImageUrl: '',
      fileList1: [{url: ''}],
      examine: '',
      //表名
      tabname: 'dmcn_article_102',
      tabContentname: 'dmcn_article_data_102',
      //fld表数据
      fldData: [],
      fldContentData: [],
      hideUploadEdit: false
    }
  },
  //根据左侧菜单栏获取模块id
  computed:
  {
    ...mapState({
      curID: state => state.NavID
    })
  },
  watch:
  {
    curID:
    {
      handler(nval, oval)
      {
        //获取分类下拉列表
        window.public.getFldvalue(nval, 'catid').then((ret) =>
        {
          this.classifydata = []
          ret.forEach((item) => this.classifydata.push({ value: item.id, label: item.dispc }))
        })
      },
      immediate: true
    }
  },
  async created()
  {
    //创建富文本编辑器
    setTimeout(() =>
    {
      let that = this
      window.public.createEditor(that)
    }, 50)
    this.fldData = await window.public.validation(this.tabname)
    this.fldContentData = await window.public.validation(this.tabContentname)
    this.isgetData()
    //根据用户判断审核状态
    let userInfo = JSON.parse(localStorage.getItem('userMsg'))
    if (userInfo.userno === 'admin')
      this.examine = 0
    else
      this.examine = 1
  },
  methods: {
    //添加
    addfn()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 22,
        retAtt: 1,
        catid: this.form.catid,
        areaid: 0,
        title: this.form.title,
        level: this.form.level,
        thumb: this.form.thumb,
        endataname: this.form.endataname,
        zhdataname: this.form.zhdataname,
        dataserialnu: this.form.dataserialnu,
        contenttype: this.form.contenttype,
        filetype: this.form.filetype,
        centergeocoordinates: this.form.centergeocoordinates,
        easternlongitude: this.form.easternlongitude,
        westlongitude: this.form.westlongitude,
        southernlatitude: this.form.southernlatitude,
        northlatitude: this.form.northlatitude,
        datashowmethodname: this.form.datashowmethodname,
        scale: this.form.scale,
        language: this.form.language,
        dataowner: this.form.dataowner,
        datastorage: this.form.datastorage,
        datasubmit: this.form.datasubmit,
        linkman: this.form.linkman,
        linkmethod: this.form.linkmethod,
        menu: this.form.menu,
        countryname: this.form.countryname,
        datapublishtime: this.form.datapublishtime,
        uid: this.form.uid,
        weight: this.form.weight,
        filesign: this.form.filesign,
        uuid: this.form.uuid,
        dataid: this.form.dataid,
        content: this.form.content,
        introduce: this.form.introduce,
        author: this.form.author,
        copyfrom: this.form.copyfrom,
        fromurl: this.form.fromurl,
        tag: this.form.tag,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000),
        hits: 0,
        examine: this.examine
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'addWithId',
          _major: 11,
          _minor: 23,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
            this.$emit('removeTab')
            this.$store.commit('onIsLb', '1')
          }
        })
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/SjgxUpdate')
        this.getData()
      else if (this.$route.path === '/SjgxLook')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 22,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.catid = ret[0].catid
        this.form.title = ret[0].title
        this.form.level = ret[0].level
        this.form.thumb = ret[0].thumb
        this.form.endataname = ret[0].endataname
        this.form.zhdataname = ret[0].zhdataname
        this.form.dataserialnu = ret[0].dataserialnu
        this.form.contenttype = ret[0].contenttype
        this.form.filetype = ret[0].filetype
        this.form.centergeocoordinates = ret[0].centergeocoordinates
        this.form.easternlongitude = ret[0].easternlongitude
        this.form.westlongitude = ret[0].westlongitude
        this.form.southernlatitude = ret[0].southernlatitude
        this.form.northlatitude = ret[0].northlatitude
        this.form.datashowmethodname = ret[0].datashowmethodname
        this.form.scale = ret[0].scale
        this.form.language = ret[0].language
        this.form.dataowner = ret[0].dataowner
        this.form.datastorage = ret[0].datastorage
        this.form.datasubmit = ret[0].datasubmit
        this.form.linkman = ret[0].linkman
        this.form.linkmethod = ret[0].linkmethod
        this.form.menu = ret[0].menu
        this.form.countryname = ret[0].countryname
        this.form.datapublishtime = ret[0].datapublishtime
        this.form.uid = ret[0].uid
        this.form.weight = ret[0].weight
        this.form.filesign = ret[0].filesign
        this.form.uuid = ret[0].uuid
        this.form.dataid = ret[0].dataid
        this.form.content = ret[0].content
        this.form.introduce = ret[0].introduce
        this.form.author = ret[0].author
        this.form.copyfrom = ret[0].copyfrom
        this.form.fromurl = ret[0].fromurl
        this.form.tag = ret[0].tag
        this.form.addtime = ret[0].addtime * 1000
        this.form.edittime = ret[0].edittime * 1000
        this.form.hits = ret[0].hits
        this.fileList1[0].url = ret[0].thumb !== '' ? ret[0].thumb : 'static/images/moren.jpg'
      })
      let paras1 = {
        cmd: 'query',
        _major: 11,
        _minor: 23,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras1).then((ret) =>
      {
        this.form.content = ret[0].content
        // 重新设置编辑器内容
        this.editor.txt.html(ret[0].content)
      })
    },
    //修改
    modification()
    {
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 22,
        retAtt: 1,
        id: this.form.id,
        catid: this.form.catid,
        title: this.form.title,
        level: this.form.level,
        thumb: this.form.thumb,
        endataname: this.form.endataname,
        zhdataname: this.form.zhdataname,
        dataserialnu: this.form.dataserialnu,
        contenttype: this.form.contenttype,
        filetype: this.form.filetype,
        centergeocoordinates: this.form.centergeocoordinates,
        easternlongitude: this.form.easternlongitude,
        westlongitude: this.form.westlongitude,
        southernlatitude: this.form.southernlatitude,
        northlatitude: this.form.northlatitude,
        datashowmethodname: this.form.datashowmethodname,
        scale: this.form.scale,
        language: this.form.language,
        dataowner: this.form.dataowner,
        datastorage: this.form.datastorage,
        datasubmit: this.form.datasubmit,
        linkman: this.form.linkman,
        linkmethod: this.form.linkmethod,
        menu: this.form.menu,
        countryname: this.form.countryname,
        datapublishtime: this.form.datapublishtime,
        uid: this.form.uid,
        weight: this.form.weight,
        filesign: this.form.filesign,
        uuid: this.form.uuid,
        dataid: this.form.dataid,
        content: this.form.content,
        introduce: this.form.introduce,
        author: this.form.author,
        copyfrom: this.form.copyfrom,
        fromurl: this.form.fromurl,
        tag: this.form.tag,
        addtime: this.form.addtime ? (this.form.addtime / 1000) : (Date.parse(new Date()) / 1000),
        edittime: (Date.parse(new Date()) / 1000)
      }
      window.post.getPost(obj).then((ret) =>
      {
        let objcontent = {
          cmd: 'updateAtt',
          _major: 11,
          _minor: 23,
          retAtt: 1,
          id: ret.id,
          content: this.form.content
        }
        window.post.getPost(objcontent).then((ret) =>
        {
          if (ret.ret === 1)
            this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
          else
          {
            this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
            this.dialogVisible = false
            this.$router.push({path: '/Sjgxgl'})
            this.$store.commit('onActiveName', '1')
          }
        })
      })
    },
    //返回
    backtrack()
    {
      this.$router.push({path: '/Sjgxgl'})
      this.$store.commit('onActiveName', '1')
    },
    backtrackLook()
    {
      this.$router.push({path: '/ToKyExamine'})
      this.$store.commit('onActiveName', '1')
    },
    //不通过
    notPass()
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 22,
        retAtt: 1,
        id: this.updataID,
        examine: 4
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '该条已为不通过', type: 'error', customClass: 'mzindex'})
          this.dialogVisible = false
          this.$router.push({path: '/ToExamine'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //通过
    isPass()
    {
      let paras = {cmd: 'query', _major: 11, _minor: 22, _exp: `id = ${this.updataID}`}
      window.post.getPost(paras).then((ret) =>
      {
        this.examineInfo = ret[0].examine
        let userInfo = JSON.parse(localStorage.getItem('userMsg'))
        let examine = null
        if (userInfo.role.includes(1) && this.examineInfo === 1)
          examine = 2
        else if (userInfo.role.includes(2) && this.examineInfo === 2)
          examine = 3
        else if (userInfo.role.includes(3) && this.examineInfo === 3)
          examine = 5
        else if (userInfo.role.includes(0))
          examine = 0
        this.upExamine(examine)
      })
    },
    //修改状态
    upExamine(examine)
    {
      let objcontent = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 22,
        retAtt: 1,
        id: this.updataID,
        examine: examine
      }
      window.post.getPost(objcontent).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '审核失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '审核成功', type: 'success', customClass: 'mzindex'})
          this.$router.go(-1)
        }
      })
    },
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    },
    /**
     * 标题检测
     * @param {String} major 主类型
     * @param {String} minor 子类型
     * @param {String} title 标题
     */
    detection(major, minor, title)
    {
      let that = this
      window.public.detection(major, minor, title, that)
    },
    //判断是否必填
    isMandatory(colname)
    {
      return window.public.isMandatory(this.fldData, colname)
    },
    //判断富文本内容是否必填
    isContentMandatory(colname)
    {
      return window.public.isMandatory(this.fldContentData, colname)
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/SjgxAdd.vue